import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_PRICE_GROUP = requestConstantsMaker('GET_ALL_PRICE_GROUP');
export const GET_PRICE_GROUP = requestConstantsMaker('GET_PRICE_GROUP');
export const CREATE_PRICE_GROUP = requestConstantsMaker('CREATE_PRICE_GROUP');
export const UPDATE_PRICE_GROUP = requestConstantsMaker('UPDATE_PRICE_GROUP');
export const GET_PRICE_GROUPS_FOR_SELECTION = requestConstantsMaker('GET_PRICE_GROUPS_FOR_SELECTION');
/**** 20200217 ****/

export const GET_ALL_PRICE_GROUP_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_PRICE_GROUP_BY_SPECIFICATION');
export const GET_PRICE_GROUP_BY_ID = requestConstantsMaker('GET_PRICE_GROUP_BY_ID');
export const POST_CREATE_PRICE_GROUP = requestConstantsMaker('POST_CREATE_PRICE_GROUP');
export const PUT_UPDATE_PRICE_GROUP = requestConstantsMaker('PUT_UPDATE_PRICE_GROUP');